import PropTypes from 'prop-types';
import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';
import Button from 'react-bootstrap/lib/Button';
import { Link } from 'react-router-dom';
import styles from './CallToAction.module.scss';

const CallToAction = ({
  cta,
  buttonText,
  to,
  panelText,
  target = '_blank',
}) => {
  return (
    <Panel className={styles.ctaPanel}>
      <div className={styles.ctaInner}>
        <h3>{cta}</h3>
        <p>{panelText}</p>
        <a href={to} target={target}>
          <button
            type="button"
            className={`btn btn-success ${styles.ctaButton}`}
          >
            {buttonText}
          </button>
        </a>
      </div>
    </Panel>
  );
};

CallToAction.propTypes = {
  cta: PropTypes.string,
  buttonText: PropTypes.string,
  to: PropTypes.string,
  target: PropTypes.string,
  panelText: PropTypes.string,
};

export default CallToAction;
